// eslint-disable-next-line import/prefer-default-export
export const OvernightCampBranchDetailsDashboardSelector = ({
  overnightCampBranchDetailsDashboardData: { OvernightCampBranchDetails }
}) => OvernightCampBranchDetails;
